var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreyDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_42975_138911)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 6.375C4.5 6.02982 4.77982 5.75 5.125 5.75H18.875C19.2202 5.75 19.5 6.02982 19.5 6.375C19.5 6.72018 19.2202 7 18.875 7H5.125C4.77982 7 4.5 6.72018 4.5 6.375Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.125 9.5C10.4702 9.5 10.75 9.77982 10.75 10.125V15.125C10.75 15.4702 10.4702 15.75 10.125 15.75C9.77982 15.75 9.5 15.4702 9.5 15.125V10.125C9.5 9.77982 9.77982 9.5 10.125 9.5Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.875 9.5C14.2202 9.5 14.5 9.77982 14.5 10.125V15.125C14.5 15.4702 14.2202 15.75 13.875 15.75C13.5298 15.75 13.25 15.4702 13.25 15.125V10.125C13.25 9.77982 13.5298 9.5 13.875 9.5Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.375 5.75C6.72018 5.75 7 6.02982 7 6.375V18.25H17V6.375C17 6.02982 17.2798 5.75 17.625 5.75C17.9702 5.75 18.25 6.02982 18.25 6.375V18.25C18.25 18.5815 18.1183 18.8995 17.8839 19.1339C17.6495 19.3683 17.3315 19.5 17 19.5H7C6.66848 19.5 6.35054 19.3683 6.11612 19.1339C5.8817 18.8995 5.75 18.5815 5.75 18.25V6.375C5.75 6.02982 6.02982 5.75 6.375 5.75Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.79918 3.79917C9.15081 3.44754 9.62772 3.25 10.125 3.25H13.875C14.3723 3.25 14.8492 3.44754 15.2008 3.79917C15.5525 4.15081 15.75 4.62772 15.75 5.125V6.375C15.75 6.72018 15.4702 7 15.125 7C14.7798 7 14.5 6.72018 14.5 6.375V5.125C14.5 4.95924 14.4342 4.80027 14.3169 4.68306C14.1997 4.56585 14.0408 4.5 13.875 4.5H10.125C9.95924 4.5 9.80027 4.56585 9.68306 4.68306C9.56585 4.80027 9.5 4.95924 9.5 5.125V6.375C9.5 6.72018 9.22018 7 8.875 7C8.52982 7 8.25 6.72018 8.25 6.375V5.125C8.25 4.62772 8.44754 4.15081 8.79918 3.79917Z",
    fill: "#4D4D4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42975_138911"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyDeleteIcon);
export default __webpack_public_path__ + "static/media/grey-delete-icon.212e3887248919c0859e83a7139f169b.svg";
export { ForwardRef as ReactComponent };